export default "__VITE_ASSET__96ef1231__"